




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import DossierApi from '@/store/api/DossierApi';
import Snackbar from '@/components/shared/Snackbar.vue';
import { IDossierOutbound } from '@/store/models/IDossierOutbound';
import ICustomer from '@/store/models/ICustomer';

@Component({ components: { Snackbar } })
export default class DossierOutbounds extends Vue {
  @Prop({ type: String, required: true }) inboundCode!: string;
  @Prop({ type: String, required: true }) idCompany!: string;
  @Prop({ type: Boolean, required: true }) ShowCustomer!: boolean;
  @Prop({ type: Array, required: true }) CustomerList!: ICustomer[];

  dossierApi = new DossierApi();
  groupedOutbounds: any[] = [];
  expanded: any[] = [];
  loadingOutbounds = false;

  outboundsHeaders = [
      { text: 'Code', value: 'code' },
      { text: 'Customer', value: 'customerName' },
      { text: 'Company Source', value: 'companySourceName' },
      { text: 'Company Destination', value: 'companyDestinationName' },
      { text: 'Date Out', value: 'dateOut' },
      { text: 'Total Cases', value: 'totalCases' },
      { text: 'Total Goods', value: 'totalGoods' }
  ];

  outboundsDetailHeaders = [
      { text: 'Good', value: 'goodName' },
      { text: 'Inbound Code', value: 'codeInbound' },
      { text: 'Total Cases', value: 'totalCases' },
      { text: 'Goods/Case', value: 'goodsPerCase' },
      { text: 'Total Goods', value: 'totalGoods' },
      { text: 'Best Before', value: 'bestBeforeDate' }
  ];

  async mounted() {
      await this.loadOutbounds();
  }

  async loadOutbounds() {
      if (!this.inboundCode) return;
      this.loadingOutbounds = true;

      try {
          const data: IDossierOutbound[] = await this.dossierApi.DossierReadOutbounds(this.inboundCode);
          if (this.ShowCustomer === false) {
              data.forEach((i) => {
                  let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                  if (indexCustomer !== -1) {
                      if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany && this.idCompany !== i.idCompanySource) {
                          i.customerName = "";
                      }
                  } else {
                      i.customerName = "";
                  }
              });
          }
          this.groupedOutbounds = Object.values(
              data.reduce((acc: any, curr: IDossierOutbound) => {
                  if (!acc[curr.id]) {
                      acc[curr.id] = {
                          id: curr.id,
                          companySourceName: curr.companySourceName,
                          companyDestinationName: curr.companyDestinationName,
                          customerName: curr.customerName,
                          customerDestination: curr.customerDestination,
                          code: curr.code,
                          dateOut: curr.dateOut,
                          weight: curr.weight,
                          liters: curr.liters,
                          containerNumber: curr.containerNumber,
                          sealNumber: curr.sealNumber,
                          orderNumber: curr.orderNumber,
                          totalCases: 0,
                          totalGoods: 0,
                          details: []
                      };
                  }

                  acc[curr.id].details.push({
                      idOutbound: curr.idOutbound,
                      codeInbound: curr.codeInbound,
                      goodName: curr.goodName,
                      totalCases: curr.totalCases,
                      goodsPerCase: curr.goodsPerCase,
                      totalGoods: curr.totalGoods,
                      bestBeforeDate: curr.bestBeforeDate,
                      weightDetail: curr.weightDetail,
                      litersDetail: curr.litersDetail,
                      totalValue: curr.totalValue
                  });

                  acc[curr.id].totalCases += curr.totalCases || 0;
                  acc[curr.id].totalGoods += curr.totalGoods || 0;
                  return acc;
              }, {})
          );
      } catch (err) {
          console.error(err);
      } finally {
          this.loadingOutbounds = false;
      }
  }

  formatDate(dateStr: string) {
      if (!dateStr) return '';
      return new Date(dateStr).toLocaleDateString();
  }
}
